var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tooltip-wrapper" },
    [
      _c("vwc-icon-button", {
        staticClass: "cd-tooltip-icon-button",
        attrs: {
          icon: _vm.toolTipInfo.icon,
          shape: "rounded",
          dense: _vm.dense,
        },
        on: {
          mouseenter: function ($event) {
            _vm.openTooltip = true
          },
          mouseleave: function ($event) {
            _vm.openTooltip = false
          },
        },
      }),
      _c("vwc-tooltip", {
        attrs: {
          open: _vm.openTooltip,
          icon: _vm.toolTipInfo.icon,
          text: _vm.toolTipInfo.text,
          anchor: _vm.toolTipInfo.id,
          corner: _vm.corner,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }